export default "__VITE_ASSET__1AkL4jOX__"